import Config from "../service/config.js";

let translations = {
  tha: {
    'epg_not_found': 'ไม่มีคู่มือโปรแกรมอิเล็กทรอนิกส์',
    'on_air': 'ออกอากาศ',
    'channels': 'ช่อง',
    'exclusive_for_ais': 'พิเศษสำหรับลูกค้าเอไอเอส'
  },
  eng: {
    'epg_not_found': 'Epg is not available',
    'on_air': 'On Air',
    'channels': 'Channels',
    'exclusive_for_ais': 'Exclusive for AIS'
  }
};


let lang_field = 'alt_lang';

export function contentLang(item = null, field = null) {
  if (!item || !field) {
    return '-';
  }
  let original = item[field];
  let lang = Config.get('language');
  if (
    item[lang_field] &&
    item[lang_field][lang] &&
    item[lang_field][lang][field]
  ) {
    return item[lang_field][lang][field];
  }
  return original;
}


export const contentTranslate = {
  methods: {

    t(item, field) {
      return contentLang(item, field);
    },
    tText(code) {
      return translations[Config.get('language')][code] || code;
    },
  }
}